import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import Icon from './icon-control'

const StickyContainer = styled.div`
  position: sticky;
  height: 0;
  z-index: 999;
  bottom: 40px;
`

const Container = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 165px;
  height: 50px;
  padding: 5px;
  background: ${colours.white};
  color: ${colours.darkBlue};
  box-sizing: border-box;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  transition: opacity 700ms, bottom 350ms, visibility 700ms;
`

const ScrollText = styled.div`
  font-weight: 500;
`
interface IProps {
  visible: boolean
}

const ScrollHintControl = (props: IProps) => {
  return (
    <StickyContainer>
      <Container
        style={{
          bottom: props.visible ? '0px' : '10px',
          opacity: props.visible ? '1' : '0',
          visibility: props.visible ? 'visible' : 'hidden'
        }}
      >
        <ScrollText>Scroll to see more</ScrollText>
        <Icon icon="chevron-down"></Icon>
      </Container>
    </StickyContainer>
  )
}

export default ScrollHintControl
